import { render, staticRenderFns } from "./organs-info.vue?vue&type=template&id=034068be&"
import script from "./organs-info.vue?vue&type=script&lang=js&"
export * from "./organs-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "organs-info.vue"
export default component.exports